/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerFindAllQueryResponse, PromptConfigurationsControllerFindAllQueryParams, PromptConfigurationsControllerFindAll401, PromptConfigurationsControllerFindAll403 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { promptConfigurationsControllerFindAll } from "../../clients/prompt-configurationsService/promptConfigurationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const promptConfigurationsControllerFindAllQueryKey = (params: PromptConfigurationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/prompt-configurations'
}, ...(params ? [params] : [])] as const;
export type PromptConfigurationsControllerFindAllQueryKey = ReturnType<typeof promptConfigurationsControllerFindAllQueryKey>;
export function promptConfigurationsControllerFindAllQueryOptions(params?: PromptConfigurationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = promptConfigurationsControllerFindAllQueryKey(params);
  return queryOptions<PromptConfigurationsControllerFindAllQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindAll401 | PromptConfigurationsControllerFindAll403>, PromptConfigurationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return promptConfigurationsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all prompt configurations with filtering and pagination
 * {@link /api/v1/prompt-configurations}
 */
export function usePromptConfigurationsControllerFindAll<TData = PromptConfigurationsControllerFindAllQueryResponse, TQueryData = PromptConfigurationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = PromptConfigurationsControllerFindAllQueryKey>(params?: PromptConfigurationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<PromptConfigurationsControllerFindAllQueryResponse, ResponseErrorConfig<PromptConfigurationsControllerFindAll401 | PromptConfigurationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? promptConfigurationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...promptConfigurationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PromptConfigurationsControllerFindAll401 | PromptConfigurationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}